import React, { useState } from 'react';

const FORM_URL = 'https://docs.google.com/forms/u/3/d/e/1FAIpQLSfisONYTSfC82vNLW3SX9zNEUlrpYyrJeHv9zRgyOOCfVLaTg/formResponse';

const FIELDS = {
    name: 'entry.553959935',
    email: 'entry.550356398',
    phone: 'entry.1419051222',
    request: 'entry.351021644',
};

const Result = () => {
    return (
        <p className="success-message">Thank you, your prayer request has been submitted.</p>
    )
}

function PrayerRequestForm() {
    const [result, showResult] = useState(false);
    const [formData, setFormData] = useState({
        [FIELDS.name]: '',
        [FIELDS.email]: '',
        [FIELDS.phone]: '',
        [FIELDS.request]: '',
    });

    const handleChange = (field) => (e) => {
        const { value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [field]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await fetch(FORM_URL, {
                method: 'POST',
                mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams(formData),
            });
        } catch (error) {
            console.error('Failed to submit prayer request:', error);
        }

        e.target.reset();
        setFormData({
            [FIELDS.name]: '',
            [FIELDS.email]: '',
            [FIELDS.phone]: '',
            [FIELDS.request]: '',
        });
        showResult(true);
        setTimeout(() => {
            showResult(false);
        }, 5000);
    };

    return (
        <div className="form-wrapper rn-form-box">
            <form onSubmit={handleSubmit} className="contact-form--1">
                <div className="row">
                    <div className="col-12 col-md-6 mb-0 mb-md-0">
                        <div className="rn-form-group">
                            <input
                                type="text"
                                name={FIELDS.name}
                                placeholder="Your Name"
                                value={formData[FIELDS.name]}
                                onChange={handleChange(FIELDS.name)}
                                required
                            />
                        </div>

                        <div className="rn-form-group">
                            <input
                                type="email"
                                name={FIELDS.email}
                                placeholder="Email (optional)"
                                value={formData[FIELDS.email]}
                                onChange={handleChange(FIELDS.email)}
                            />
                        </div>

                        <div className="rn-form-group">
                            <input
                                type="text"
                                name={FIELDS.phone}
                                placeholder="Phone Number (optional)"
                                value={formData[FIELDS.phone]}
                                onChange={handleChange(FIELDS.phone)}
                            />
                        </div>
                    </div>

                    <div className="col-12 col-md-6 d-flex flex-column">
                        <div className="rn-form-group flex-grow-1 d-flex flex-column">
                            <textarea
                                name={FIELDS.request}
                                placeholder="Your Prayer Request"
                                value={formData[FIELDS.request]}
                                onChange={handleChange(FIELDS.request)}
                                required
                            ></textarea>
                        </div>

                        <div className="rn-form-group">
                            <button className="btn-default btn-border btn-opacity" type="submit">
                                <span>Submit Prayer Request</span>
                            </button>
                        </div>

                        <div className="rn-form-group">
                            {result ? <Result /> : null}
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default PrayerRequestForm;
